import React from "react";
import { LOGO_URL } from "@/lib/api";
import { Mail } from "lucide-react";
import { InstallAppButton } from "@/components/InstallAppButton";
import { SocialLinks } from "@/components/SocialLinks";

export const Footer = () => {
  return (
    <footer className="bg-black text-white border-t-4 border-candy-pink">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
        <div className="sm:col-span-2">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="logo" className="h-14 w-14 rounded-full border-2 border-white" />
            <div>
              <div className="font-display text-3xl tracking-wide text-candy-pink">THE SWEET TOOTH</div>
              <div className="font-display text-2xl tracking-[0.3em] text-candy-teal -mt-1">BANDIT</div>
            </div>
          </div>
          <p className="mt-4 text-white/70 max-w-sm font-medium text-sm">
            Nostalgic American candy & merch. Est. 2023. The mark
            &ldquo;The Sweet Tooth Bandit&rdquo; and mascot are original works of the shop owner.
          </p>
        </div>

        <div>
          <h4 className="font-heading font-600 uppercase tracking-widest text-sm text-candy-gold">Shop</h4>
          <ul className="mt-3 space-y-2 text-sm text-white/80">
            <li><a href="#shop-fall" data-testid="footer-shop-fall" className="hover:text-candy-pink">Fall Candy Bouquets</a></li>
            <li><a href="#shop-christmas" data-testid="footer-shop-christmas" className="hover:text-candy-pink">Christmas Candy Bouquets</a></li>
            <li><a href="#shop-stuffers" data-testid="footer-shop-stuffers" className="hover:text-candy-pink">Stocking Stuffers</a></li>
            <li><a href="#shop-merch" data-testid="footer-shop-merch" className="hover:text-candy-pink">Merch</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-600 uppercase tracking-widest text-sm text-candy-gold">Connect</h4>
          <a href="mailto:Sweettoothbanditshop@outlook.com" className="mt-3 flex items-center gap-2 text-sm text-white/80 hover:text-candy-pink">
            <Mail className="h-4 w-4" /> Email us
          </a>
          <div className="mt-3">
            <SocialLinks tileClass="border-2 border-white/40 rounded-lg p-2 hover:border-candy-pink hover:text-candy-pink transition-colors" iconClass="h-4 w-4" />
          </div>
          <div className="mt-4"><InstallAppButton variant="outline" /></div>
          <a href="/admin" data-testid="footer-admin-link" className="mt-4 inline-block text-xs text-white/40 hover:text-white/80">Owner Login</a>
        </div>
      </div>
      <div className="border-t border-white/20 py-4 text-center text-xs text-white/50">
        © {new Date().getFullYear()} The Sweet Tooth Bandit Candy Co. All rights reserved.
        <div className="mt-1 text-white/40">Music: "Jingle Bells" by Kevin MacLeod (incompetech.com), CC BY 4.0</div>
      </div>
    </footer>
  );
};
